import { render, staticRenderFns } from "./migrate.vue?vue&type=template&id=4d8c1f8c"
import script from "./migrate.vue?vue&type=script&lang=ts"
export * from "./migrate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports